module.exports = __webpack_public_path__ + "1b97fd52917246f1ea234793f6e1f5d7.pdf";